<!-- components/AllCoursesGrid.vue -->
<template>
  <section class="py-12 px-6 md:px-12 bg-white" id="cursos">
    <div
      class="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
    >
      <div
        v-for="course in props.courses"
        :key="course.id"
        class="bg-white overflow-hidden p-[24px] mt-3 item cursor-pointer relative"
        @click="navigateTo('/formaciones/' + course.id)"
      >
        <div
          class="absolute top-10 left-10 text-sm font-poppins text-white font-medium px-3 py-1 module"
        >
          {{ course.modules.length }} Módulos
        </div>
        <img
          :src="course.imageUrl"
          class="w-full object-cover rounded-xl h-48"
          alt="course"
        />
        <div class="p-4 pb-0">
          <h3 class="text-base font-bold text-gray-900 mb-2 font-poppins">
            {{ course.title }}
          </h3>
          <p class="text-sm text-[#4D617C] font-poppins">
            {{ course.description.slice(0, 100) + "..." }}
          </p>
        </div>
      </div>
    </div>

    <div class="mt-12 flex justify-end me-4">
      <div>
        <UiPagination
          v-if="pageCount > 1"
          :current-page="page"
          :page-count="pageCount"
          @change="onPageChange"
        />
      </div>
    </div>
    <!-- Pagination -->
  </section>
</template>

<script setup lang="ts">
const props = defineProps<{
  courses: any[];
  totalItem: number;
  loading: boolean;
  loadingMore: boolean;
  page: number;
  pageCount: number;
}>();
const { courses, totalItem, loading, loadingMore } = toRefs(props);

const emit = defineEmits<{ (e: "change-page", page: number): void }>();

function onPageChange(p: number) {
  emit("change-page", p);
}
</script>
<style scoped>
.item {
  border-radius: 16px;
  background: var(--White, #fff);
  box-shadow: 0 5px 10px 0 rgba(49, 49, 49, 0.1);
}
button {
  width: 56px;
  height: 56px;
  transition: all 0.3s ease;
}
.module {
  border-radius: 32px;
  background: var(--Glass-Grey, rgba(194, 194, 194, 0.5));
  box-shadow: 0 5px 5px 0 rgba(49, 49, 49, 0.1);
  backdrop-filter: blur(8px);
}
</style>
